import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LinkUnderline, ErrorForm, Button, InputForm } from '../../components'
import { useForm, Controller } from 'react-hook-form'
import { useYupValidation } from '../../hooks'
import { requestAccessSchema } from '../../yup'
import { IAuthAccess } from '../../interfaces'
import { errorHandler } from '../../services'
import { AuthService } from '../../services/index'
import logo from '../../assets/images/logo.png'
import { toast } from 'react-toastify'
import { cpfMask, unMaskInputs } from '../../utils'
import { ERROR_TYPE } from '../../enums/errorType'
import { AxiosError } from 'axios'

export default function Access(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const navigate = useNavigate()

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthAccess>({
        resolver: useYupValidation(requestAccessSchema),
    })

    async function signUp(values: IAuthAccess): Promise<void> {
        setIsLoading(true)
        try {
            const response = await AuthService.postSignUp({ ...values, cpf: unMaskInputs(values.cpf) })
            toast(response.message, { type: 'success' })
            navigate('/received-request')
        } catch (err) {
            if (err instanceof AxiosError) {
                const type = err.response?.data.errorType
                toast(errorHandler(err).message, {
                    type: type === ERROR_TYPE.USER_AWAITING ? 'warning' : 'error',
                })
            }
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div id="access__form">
            <div className="access__backgound">
                <div className="access__content">
                    <div className="access__images">
                        <img src={logo} alt="Logo CNA construtora" className="access__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Solicite seu cadastro.</h4>
                    <form className="access__inputs" onSubmit={handleSubmit(signUp)}>
                        <Controller
                            name="name"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm label="Nome" placeholder="Nome" name="name" value={value} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.name?.message} />
                        <Controller
                            name="cpf"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm label="CPF" placeholder="CPF" name="cpf" value={cpfMask(value)} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.cpf?.message} />
                        <Controller
                            name="email"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm label="E-mail" placeholder="E-mail" name="email" value={value} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.email?.message} />
                        <Controller
                            name="password"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputForm
                                        label="Sua senha"
                                        type="password"
                                        placeholder="Sua Senha"
                                        name="password"
                                        value={value}
                                        onChange={onChange}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors.password?.message} />
                        <Controller
                            name="passwordConf"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputForm
                                        label="Confirmação de senha"
                                        type="password"
                                        placeholder="Confirmação de senha"
                                        name="passwordConf"
                                        value={value}
                                        onChange={onChange}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors.passwordConf?.message} />
                        <div className="box-options">
                            <LinkUnderline placeholder="Fazer login" onClick={() => navigate('/login')} />
                            <LinkUnderline placeholder="Esqueci minha senha" onClick={() => navigate('/forgot-pass')} />
                        </div>
                        <div className="box-button-access">
                            <Button isLoading={isLoading} type={'submit'} placeholder="Solicitar cadastro" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
